import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { Box, Tooltip } from "@mui/material";
import { Icon } from "@sequentech/ui-essentials";
import { theme } from "@sequentech/ui-essentials";
var PREFIX = "IconTooltip";
var classes = {
    tooltip: "".concat(PREFIX, "-tooltip"),
    arrow: "".concat(PREFIX, "-arrow"),
};
var StyledTooltip = styled(Tooltip)(function () {
    var _a;
    return (_a = {},
        _a["& .".concat(classes.tooltip)] = {
            backgroundColor: "".concat(theme.palette.blue.light),
            color: "rgba(0, 0, 0)",
            width: "220px",
            fontSize: "".concat(theme.typography.pxToRem(12)),
            padding: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
        },
        _a["& .".concat(classes.arrow)] = {
            color: "".concat(theme.palette.blue.light),
            fontSize: "20px",
            transform: "translate3d(190px, 0px, 0px) !important",
        },
        _a);
});
var IconTooltip = function (_a) {
    var icon = _a.icon, info = _a.info, _b = _a.infoContainerWidth, infoContainerWidth = _b === void 0 ? "250px" : _b;
    return (_jsx(StyledTooltip, { title: info, arrow: true, placement: "bottom-end", classes: { tooltip: classes.tooltip, arrow: classes.arrow }, slotProps: {
            popper: {
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [30, 0],
                        },
                    },
                ],
            },
        }, children: _jsx(Box, { sx: { width: "30px" }, children: _jsx(Icon, { icon: icon }) }) }));
};
export default IconTooltip;
